/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    const LOCALE_TYPE = "Locale";
    const LOG_CATEGORY = "WPT.Locale";
    const QUERYSTRING_LOCALE = "locale";
    const DEFAULT_LOCALE_CODE = 'en-GB';
    const DEFAULT_LOCALE = { LocaleCode: DEFAULT_LOCALE_CODE, Name: "United Kingdom", Active: true, Code: "GB" };
    const DATE_OPTIONS = { day: "2-digit", month: "2-digit", year: "numeric" };
    const DATETIME_OPTIONS = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" };
    const NUMBER_OPTIONS = { maximumFractionDigits: 10 };
    const NUMBER_OPTIONS_NOGROUPING = { maximumFractionDigits: 10, useGrouping: false };
    const CURRENCY_OPTIONS = { maximumFractionDigits: 10, minimumFractionDigits: 2 };
    const CURRENCY_OPTIONS_NOGROUPING = { maximumFractionDigits: 10, minimumFractionDigits: 2, useGrouping: false };
    let LocaleStages;
    (function (LocaleStages) {
        LocaleStages[LocaleStages["UNKNOWN"] = 0] = "UNKNOWN";
        LocaleStages[LocaleStages["INIT"] = 1] = "INIT";
        LocaleStages[LocaleStages["LOCALESSET"] = 2] = "LOCALESSET";
        LocaleStages[LocaleStages["LOCALESELECTED"] = 3] = "LOCALESELECTED";
        LocaleStages[LocaleStages["READY"] = 4] = "READY";
    })(LocaleStages || (LocaleStages = {}));
    /**
     * Class holding locale/lang logic. Depends on WPT Loader "module".
     */
    class LocaleManager {
        constructor(core) {
            this._log = null;
            this._currentStage = LocaleStages.UNKNOWN;
            this._languages = null;
            this._visibleLanguages = null;
            this._selectedLocale = null;
            this._translations = null;
            this._customTranslations = null;
            this._configReady = false;
            this._customFilesRequested = false;
            this.Type = LOCALE_TYPE;
            this.initLogging = () => {
                
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
            };
            this.setConfigurationReady = () => {
                this._configReady = true;
                if (!this._customFilesRequested)
                    this._loadCustomLanguageFiles();
            };
            /**
             * Get visible languages.
             * @returns array of visible languages and their subcategories
             */
            this.getVisibleLanguages = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager.getVisibleLanguages()");
                }
                else {
                    
                }
                return this._visibleLanguages;
            };
            /**
             * Get selected locale.
             * @returns selected locale data
             */
            this.getSelectedLocale = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager.getSelectedLocale()");
                }
                else {
                    
                }
                return this._selectedLocale;
            };
            /**
             * Changes the locale.
             * @param newLocale code of the locale to choose
             * @returns 'true' if the locale was found, otherwise 'false'
             */
            this.changeLocale = (newLocale) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager.changeLocale()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("looking for locale: " + newLocale);
                }
                else {
                    
                }
                let localeFound = false;
                if (newLocale != null && newLocale != undefined && newLocale.length > 0) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("new locale name provided");
                    }
                    else {
                        
                    }
                    if (this._selectedLocale.LocaleCode != newLocale) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("new locale name is not the selected");
                        }
                        else {
                            
                        }
                        let localeConfig = this._getLocaleConfig(newLocale);
                        if (localeConfig != null) {
                            this._selectedLocale = localeConfig;
                            localeFound = true;
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("selected locale: " + this._selectedLocale.LocaleCode);
                            }
                            else {
                                
                            }
                            this._currentStage = LocaleStages.LOCALESELECTED;
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("current stage: " + LocaleStages[this._currentStage]);
                            }
                            else {
                                
                            }
                            this._loadSelectedLocale(true);
                        }
                    }
                }
                return localeFound;
            };
            /**
             * Gets the translation for a string.
             * @param translationString string for which a translation is searched
             * @returns translated string if available in custom translations or translations, otherwise requested string
             */
            this.getTranslation = (translationString) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager.getTranslation()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("looking for translation of: " + translationString);
                }
                else {
                    
                }
                if (this._customTranslations.hasOwnProperty(translationString)) {
                    let result = this._customTranslations[translationString];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("found custom translation: " + result);
                    }
                    else {
                        
                    }
                    return result;
                }
                if (this._translations.hasOwnProperty(translationString)) {
                    let result = this._translations[translationString];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("found translation: " + result);
                    }
                    else {
                        
                    }
                    return result;
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("no translation found");
                }
                else {
                    
                }
                return translationString;
            };
            /**
             * Error callback for loading locales.json.
             * @param url URL used for the attempt to get locales.json
             * @param status status code for the attempt to get locales.json
             * @param statusText status text for the attempt to get locales.json
             */
            this._noLocaleData = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._noLocaleData()");
                }
                else {
                    
                }
                let msg = "failed to get locales.json from '" + url + "': " + status + " - " + statusText;
                console.error(msg);
                // using alert, since basic functionality is not given
                alert(msg);
            };
            /**
             * Callback for loading locales.json.
             * @param configData locale data from locales.json
             */
            this._setLocaleData = (localeData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._setLocaleData()");
                }
                else {
                    
                }
                if (localeData.hasOwnProperty("Locales")) {
                    this._languages = localeData.Locales;
                }
                else {
                    this._languages = [];
                    let msg = "missing property 'Locales' in locales.json";
                    console.error(msg);
                    // using alert, since basic functionality is not given
                    alert(msg);
                }
                this._filterActiveLocales();
                this._currentStage = LocaleStages.LOCALESSET;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("current stage: " + LocaleStages[this._currentStage]);
                }
                else {
                    
                }
                // read query string parameter for locale and select the one to use
                let queryLocale = this._core.getQueryStringValue(QUERYSTRING_LOCALE);
                let needsQueryUpdate = this._selectLocale(queryLocale);
                // load the selected locale
                this._loadSelectedLocale(needsQueryUpdate);
            };
            /**
             * Filter active major languages and regions.
             */
            this._filterActiveLocales = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._filterActiveLocales()");
                }
                else {
                    
                }
                this._visibleLanguages = [];
                let languages = this._languages.slice();
                let languagesLength = languages.length;
                for (let i = 0; i < languagesLength; i++) {
                    let language = languages[i];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("looking at language: " + language.LangCode);
                    }
                    else {
                        
                    }
                    if (language.hasOwnProperty('Active') && language.Active) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("language active");
                        }
                        else {
                            
                        }
                        // create independent copy to avoid changes in underlying data
                        let resultLang = JSON.parse(JSON.stringify(language));
                        // using slice to create a copy of the array in order to avoid changes in it
                        let regions = resultLang.Subcategories.slice();
                        let regionsLength = regions.length;
                        // clear subcategories and fill with active regions
                        resultLang.Subcategories = [];
                        for (let j = 0; j < regionsLength; j++) {
                            let region = regions[j];
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("looking at region: " + region.Code);
                            }
                            else {
                                
                            }
                            if (region.hasOwnProperty('Active') && region.Active) {
                                if (this._log !== null && this._log.isTraceEnabled()) {
                                    this._log.trace("region active");
                                }
                                else {
                                    
                                }
                                if (!region.hasOwnProperty('LocaleCode') || region.LocaleCode === null || region.LocaleCode === undefined || region.LocaleCode.length === 0) {
                                    region.LocaleCode = language.LangCode + "-" + region.Code;
                                }
                                resultLang.Subcategories.push(region);
                            }
                            else {
                                if (this._log !== null && this._log.isTraceEnabled()) {
                                    this._log.trace("region inactive");
                                }
                                else {
                                    
                                }
                            }
                        }
                        // only add major languages with at least one active region
                        if (resultLang.Subcategories.length > 0) {
                            this._visibleLanguages.push(resultLang);
                        }
                    }
                    else {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("language inactive");
                        }
                        else {
                            
                        }
                    }
                }
            };
            /**
             * Select the locale based on query string parameter or navigator languages and configured locales.
             * @param queryLocale query string parameter or 'undefined'
             * @returns decision whether the query string parameter needs an update
             */
            this._selectLocale = (queryLocale) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._selectLocale()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("looking for locale: " + queryLocale);
                }
                else {
                    
                }
                let localeConfig = null;
                let needsQueryUpdate = true;
                if (queryLocale != null && queryLocale != undefined && queryLocale.length > 0) {
                    localeConfig = this._getLocaleConfig(queryLocale);
                    if (localeConfig != null && localeConfig != undefined) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("locale found");
                        }
                        else {
                            
                        }
                        needsQueryUpdate = false;
                    }
                }
                if (localeConfig == null || localeConfig == undefined) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("no query parameter value for locale found, using navigator languages");
                    }
                    else {
                        
                    }
                    let languages = navigator.languages;
                    let languagesLength = languages.length;
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("using navigator languages: " + languages);
                    }
                    else {
                        
                    }
                    for (let i = 0; i < languagesLength; i++) {
                        let lang = languages[i];
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("looking at navigator language: " + lang);
                        }
                        else {
                            
                        }
                        localeConfig = this._getLocaleConfig(lang);
                        if (localeConfig != null && localeConfig != undefined) {
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("locale found");
                            }
                            else {
                                
                            }
                            break;
                        }
                    }
                }
                // fallback if no locale could be selected
                if (localeConfig == null || localeConfig == undefined) {
                    console.warn("unable to select a locale, using default: " + DEFAULT_LOCALE_CODE);
                    localeConfig = DEFAULT_LOCALE;
                }
                this._selectedLocale = localeConfig;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("selected locale: " + this._selectedLocale.LocaleCode);
                }
                else {
                    
                }
                this._currentStage = LocaleStages.LOCALESELECTED;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("current stage: " + LocaleStages[this._currentStage]);
                }
                else {
                    
                }
                return needsQueryUpdate;
            };
            /**
             * Get the locale configuration data for a locale code.
             * @param queryLocale the locale code to look for
             * @returns the locale configuration data or NULL
             */
            this._getLocaleConfig = (queryLocale) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._getLocaleConfig()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("getting locale: " + queryLocale);
                }
                else {
                    
                }
                let result = null;
                let visibleLength = this._visibleLanguages.length;
                for (let i = 0; i < visibleLength; i++) {
                    let language = this._visibleLanguages[i];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("looking at language: " + language.LangCode);
                    }
                    else {
                        
                    }
                    if (queryLocale == language.LangCode || queryLocale.startsWith(language.LangCode + "-")) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("found language");
                        }
                        else {
                            
                        }
                        let code = null;
                        if (queryLocale == language.LangCode) {
                            // just major language provided, use default code
                            code = language.DefaultCode;
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("using default code: " + code);
                            }
                            else {
                                
                            }
                        }
                        else {
                            code = queryLocale.substring(language.LangCode.length + 1);
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("using code: " + code);
                            }
                            else {
                                
                            }
                        }
                        let regionsLength = language.Subcategories.length;
                        for (let j = 0; j < regionsLength; j++) {
                            let region = language.Subcategories[j];
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("looking at region: " + region.Code);
                            }
                            else {
                                
                            }
                            if (code == region.Code) {
                                if (this._log !== null && this._log.isTraceEnabled()) {
                                    this._log.trace("region found");
                                }
                                else {
                                    
                                }
                                result = region;
                                break;
                            }
                        }
                    }
                    if (result != null) {
                        break;
                    }
                }
                return result;
            };
            /**
             * Load the selected locale and update query string parameter if necessary.
             * @param needsQueryUpdate decision whether the query string parameter needs an update
             */
            this._loadSelectedLocale = (needsQueryUpdate) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._loadSelectedLocale()");
                }
                else {
                    
                }
                let localeCode = this._selectedLocale.LocaleCode;
                // check whether the query string parameter needs an update
                if (needsQueryUpdate) {
                    this._core.changeQueryStringValue(QUERYSTRING_LOCALE, localeCode);
                }
                // initialise the locale based formatters
                let locales = [localeCode, DEFAULT_LOCALE_CODE];
                this.DateFormatter = new Intl.DateTimeFormat(locales, DATE_OPTIONS);
                this.DatetimeFormatter = new Intl.DateTimeFormat(locales, DATETIME_OPTIONS);
                this.NumberFormatter = new Intl.NumberFormat(locales, NUMBER_OPTIONS);
                this.NumberNoGroupingFormatter = Intl.NumberFormat(locales, NUMBER_OPTIONS_NOGROUPING);
                this.CurrencyFormatter = new Intl.NumberFormat(locales, CURRENCY_OPTIONS);
                this.CurrencyNoGroupingFormatter = new Intl.NumberFormat(locales, CURRENCY_OPTIONS_NOGROUPING);
                // load the translation files and store values
                let langFileCode = this._getLangFileCode();
                this._selectedLocale.LangFileCode = langFileCode;
                document.documentElement.lang = langFileCode;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("loading language files with language file code: " + langFileCode);
                }
                else {
                    
                }
                this._customFilesRequested = false; // reset in order to allow reload of custom lang and do the whole reinit
                this._translations = null;
                this._customTranslations = null;
                this._loadCustomLanguageFiles();
                this._core.waitForVersionSet().then(this._core.Loader.getVersionedJSON.bind(this, "./lang/lang-" + langFileCode + ".json", this._setTranslationData, this._noTranslationData));
            };
            this._loadCustomLanguageFiles = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._loadCustomLanguageFiles()");
                }
                else {
                    
                }
                if (!this._configReady)
                    return;
                if (this._customFilesRequested)
                    return;
                this._customFilesRequested = true;
                let langFileCode = this._getLangFileCode();
                // We know this will be set, the code defaults it to {}
                let resources = this._core.Config.getMainConfig().Resources;
                if (resources.hasOwnProperty('RemoteCustomLangFiles') && (resources.RemoteCustomLangFiles != null)) {
                    let locator = {
                        Instance: resources.RemoteCustomLangFiles.Instance,
                        FileType: 'CUSTOM-LANGUAGE',
                        Id: resources.RemoteCustomLangFiles.Id.replace('{languagecode}', langFileCode)
                    };
                    this._core.Loader.retrieveConfigData(locator, this._receiveCustomLangFromOnBase, this._noCustomTranslationData);
                }
                else {
                    this._core.Loader.getUnversionedJSON("./custom/lang/customLang-" + langFileCode + ".json", this._setCustomTranslationData, this._noCustomTranslationData);
                }
            };
            this._receiveCustomLangFromOnBase = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._receiveCustomLangFromOnBase()");
                }
                else {
                    
                }
                if (response.hasOwnProperty('ContentText') && response.ContentText) {
                    let translations = JSON.parse(response.ContentText);
                    this._setCustomTranslationData(translations);
                }
                else
                    this._noCustomTranslationData('(OnBase)', 0, 'No translations found in custom language file retrieved from Onbase.');
            };
            /**
             * Gets the code for the languages files to load.
             * @returns code for the languages files to load
             */
            this._getLangFileCode = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._getLangFileCode()");
                }
                else {
                    
                }
                let result = this._selectedLocale.LocaleCode;
                if (this._selectedLocale.hasOwnProperty('LangFileCode') && this._selectedLocale.LangFileCode.length > 0) {
                    result = this._selectedLocale.LangFileCode;
                }
                return result;
            };
            /**
             * Callback for loading translation data.
             * @param translationData translation data
             */
            this._setTranslationData = (translationData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._setTranslationData()");
                }
                else {
                    
                }
                if (translationData.hasOwnProperty("Translate")) {
                    this._translations = translationData.Translate;
                }
                else {
                    console.warn("missing property 'Translate' in lang-" + this._getLangFileCode() + ".json");
                    // set translations to empty array to avoid errors later on
                    this._translations = [];
                }
                if (this._customTranslations != null) {
                    this._finishInitialisation();
                }
            };
            /**
             * Error callback for loading translation data.
             * @param url URL used for the attempt to get translation data
             * @param status status code for the attempt to get translation data
             * @param statusText status text for the attempt to get translation data
             */
            this._noTranslationData = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._noTranslationData()");
                }
                else {
                    
                }
                console.error("failed to get translation from '" + url + "': " + status + " - " + statusText);
                // set translations to empty array to avoid errors later on
                this._translations = [];
                if (this._customTranslations != null) {
                    this._finishInitialisation();
                }
            };
            /**
             * Callback for loading custom translation data.
             * @param translationData custom translation data
             */
            this._setCustomTranslationData = (translationData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._setCustomTranslationData()");
                }
                else {
                    
                }
                if (translationData.hasOwnProperty("Translate")) {
                    this._customTranslations = translationData.Translate;
                }
                else {
                    console.warn("missing property 'Translate' in customLang-" + this._getLangFileCode() + ".json");
                    // set translations to empty array to avoid errors later on
                    this._customTranslations = [];
                }
                if (this._translations != null) {
                    this._finishInitialisation();
                }
            };
            /**
             * Error callback for loading custom translation data.
             * @param url URL used for the attempt to get custom translation data
             * @param status status code for the attempt to get custom translation data
             * @param statusText status text for the attempt to get custom translation data
             */
            this._noCustomTranslationData = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._noCustomTranslationData()");
                }
                else {
                    
                }
                console.warn("failed to get custom translation from '" + url + "': " + status + " - " + statusText);
                // set custom translations to empty array to avoid errors later on
                this._customTranslations = [];
                if (this._translations != null) {
                    this._finishInitialisation();
                }
            };
            /**
             * Finishes the initialisation and informs the core about it.
             */
            this._finishInitialisation = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LocaleManager._finishInitialisation()");
                }
                else {
                    
                }
                this._currentStage = LocaleStages.READY;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("current stage: " + LocaleStages[this._currentStage]);
                }
                else {
                    
                }
                // let WPT know that we are ready
                this._core.moduleInitialisationFinished(this);
            };
            
            this._core = core;
            this._currentStage = LocaleStages.INIT;
            // load locales.json and start handling of locales data
            this._core.Loader.getUnversionedJSON('./config/locales.json', this._setLocaleData, this._noLocaleData);
        }
    }
    WPTNamespace.LocaleManager = LocaleManager;
})(WPTNamespace || (WPTNamespace = {}));
